import React from 'react';
import store from '../store';
import FloatButton from '../components/FloatButton';
//import CardContent from '../components/CardContent';
import Toolbar from '../components/Toolbar';
import DialogVideo from '../components/DialogVideo';
import CardFile from '../components/CardFile';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import  FormControl  from '@material-ui/core/FormControl';
import Button  from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import GroupWorkIcon from '@material-ui/icons/Group';
import ReceiptIcon from '@material-ui/icons/Receipt';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddIcon from '@material-ui/icons/Add';
import Dropzone from "react-dropzone";
const DWIDTH = 640;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function guid() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 10; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

const styles = theme => ({
    title: {
        marginBottom: theme.spacing.unit * 2,
        padding: 0
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    },
    buttonAdd: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}


class AdminVideo extends React.Component {
    constructor() {
        super();
        this.state = { search: '',contents:[],open:false,loading:false};

    }
    loadContents(){
      console.log('load Contents');
      let _this = this;
      let sub = firebase.firestore().collection('files').orderBy('created','desc').onSnapshot((data)=>{
        let contents = [];
        data.forEach((doc)=>{
          let item = doc.data();
          item.id=doc.id;
          contents.push(item);
        })

        _this.setState({contents});
      })
      _this.setState({sub});
    }

    componentDidMount(){
      this.loadContents();

    }
    componentWillUnmount(){
      if(this.state.sub)
      this.state.sub();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    handleClose = value => {
        this.setState({ open: false });
    };
    handleClickOpen = () => {
            this.setState({
                open: true,
            });
        };
      async  _onDropImages(files) {
        if(this.state.loading)
        {
          alert("Please wait uploading finish");
          return;
        }
                this.setState({loading:true});
                  for (var file of files)
                  {
                    var filename = guid()+"."+file.name.split('.').pop();
                    console.log(filename)
                    try {
                      await firebase.storage().ref().child('files/' + filename).put(file);
                      let item = {name:file.name,uri:filename,created:(new Date().getTime())};
                      firebase.firestore().collection('files').doc().set(item);
                      }
                      catch(e)
                      {
                        console.log(e);
                      }
                  }
                  this.setState({loading:false});

              }


    render() {
        const { classes } = this.props;
        const { search,contents,loading } = this.state;

        const item_button =  { name:"", link:"",order:0,created:(new Date()).getTime() };
        if(!store.getState().ADMINACCOUNT)
        {
          console.log('No Admin');
          return <Redirect to='/sbadmin' />
        }
        return (
          <div>
          <Toolbar/>
            <div style={{ maxWidth: '720px',margin: '20px auto',paddingTop: '64px'}}>
                <Grid justify="flex-start" direction="row" container>
                    <Grid item><AllInboxIcon style={{ marginRight: 10 }} /></Grid>
                    <Grid item><Typography variant="title" className={classes.title}>Files</Typography></Grid>
                </Grid>
                
                <Dropzone onDrop={this._onDropImages.bind(this)} disabled={loading} accept="image/jpeg, image/png,audio/mpeg" style={{display: 'flex', justifyContent: 'center', alignItems: 'center',width: '150px',height: '150px',borderWidth: '2px',borderColor: 'rgb(102, 102, 102)',borderStyle: 'dashed',borderRadius: '5px'}} >
                                              {loading?"Uploading":<AddIcon style={{ fontSize: 60 }}/>}
                                            </Dropzone>
                                            <div>*Only jpg/png or mp3 file accept</div>
                {this.state.contents.filter(i => {
                    let f = search.toLowerCase();
                    return a(i.name,f) ;
                }).map((item, index) => {
                    return <CardFile item={item} key={index} />
                })}
                <div style={{ height: 100, display: 'block' }} />

                </div>
                <div>
                                {this.state.open ? '' :
                                    <Button onClick={this.handleClickOpen} variant="fab" color="secondary" aria-label="add" className={classes.buttonAdd}>
                                        <AddIcon />
                                    </Button>}
                                {this.state.open ?<DialogVideo
                                    item={item_button}
                                    fullScreen={true}
                                    open={this.state.open}
                                    onClose={this.handleClose}
                                />:false}
                            </div>
            </div>
        )
    }
}

AdminVideo.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminVideo);
